<template>
  <header class="header" :class="{ fixed: fixed }">
    <div class="content" :style="{padding: showClientBtns?'0 0 0 18px':'0 30px'}">
      <div>
        <img
          class="logo header-com"
          style="cursor: pointer"
          @click="loginClick"
          src="@images/header-logo.png"
        />
        <div class="nav-list header-com" v-if="false">
          <template v-for="(item, index) in $store.state.config.nav">
            <a
              class="nav-item"
              :key="index"
              :href="item.href"
              :class="{ active: isActive(item) }"
              @click="clickHandler($event, item.click)"
              v-czc="['导航栏', '导航', item.title, 0, `nav-btn-${item.nodeid}`]"
            >
              {{ item.title }}
            </a>
          </template>
        </div>
        <div class="nav-menu header-com">
          <el-menu
            id="menu"
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            active-text-color="#3D7EFF"
            text-color="#333"
          >
            <template v-for="item in $store.state.config.newNav">
              <template v-if="!!item.children">
                <el-submenu :index="item.id" :key="item.id">
                  <template slot="title">
                    <span class="menu-title">{{ item.title }}</span>
                  </template>
                  <el-menu-item
                    v-for="childItem in item.children"
                    :index="childItem.id"
                    :key="childItem.id"
                  >
                    <span class="menu-submenu-title">{{ childItem.title }}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
              <el-menu-item :index="item.id" :key="item.id" v-else>
                <span class="menu-title">{{ item.title }}</span>
                <img
                  class="closeImg"
                  src="@images/hot.gif"
                  alt=""
                  style="width: 26px"
                  v-if="item.id == 9 || item.id == 6"
                />
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
      <div class="search" :style="{ float: 'right' }">
        <user id="user"></user>
        <div class="clientBtns noDrag" v-if="showClientBtns">
          <ClientBtns/>
        </div>
      </div>
    </div>
    <!-- 会员领取弹窗 -->
    <vip-dialog></vip-dialog>
    <!-- 会员体验特权到期弹窗 -->
    <tryon-dialog ref="tryon" @close="closeTryon" :ispower="isPower"></tryon-dialog>
    <!-- 一键发公告校验是否有权限 -->
    <public-power ref="power"></public-power>
    <slot></slot>
  </header>
</template>

<script>
// import Search from './components/search';
import User from "./components/user";
import vipDialog from "./components/vip-dialog";
import tryonDialog from "./components/tryon-dialog";
import publicPower from "./components/public-power";
import { mapGetters, mapActions, mapMutations } from "vuex";
// import SearchDealNav from './components/search-deal-nav.vue';
import ClientBtns from '../headerIndexIcon/client-btns'
export default {
  components: {
    // Search,
    User,
    vipDialog,
    tryonDialog,
    // SearchDealNav,
    publicPower,
    ClientBtns
  },
  props: {
    theme: {
      type: String,
      default: "",
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      useSearchDeal: false, //是否使用 (查交易中心、查公告、查企业) 搜索组件
      activeIndex: "",
      searchInput: "",
      inputWidth: "600px",
      isPower: false,
      showClientBtns: false
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfo/getData"
    }),
  },
  watch: {
    "$route.path"(e) {
      this.setDefaultIndex(e);
      var nuxtCon = document.querySelector("#__nuxt");

      if (!nuxtCon) {
        return;
      }

      nuxtCon.scrollTo(0, 0);
    },
    '$store.state.userinfo.showLoginFlag': {
      handler(val) {
        if (!val) {
          $.ajax({
            url: `${this.$store.state.api.webUrl}/userlogin/isSetPwd.json`,
            type: "get",
            dataType: "json",
            success: (data) => {
              if(!data.tdata){
                this.$confirm("账号还未设置密码，请修改密码?", "提示", {
                  confirmButtonText: "确认",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then((res) => {
                  this.goto(`/user/password`);
                });
              }
            },
          })
        }
      }
    }
  },
  methods: {
    //点击logo 跳转首页
    loginClick() {
      if (this.$route.path != "/") {
        window.location.assign("/");
      }
    },
    isActive(item) {
      var path = this.$route.path,
        href = item.href,
        activeReg = item.activeReg;

      if (href === path) {
        return true;
      }

      if (path === href) {
        return true;
      }

      if (activeReg && activeReg.test(path)) {
        return true;
      }

      return false;
    },
    clickHandler(e, cb) {
      if (cb) {
        e.preventDefault();

        try {
          this[cb]();
        } catch (error) {}
        // var fun = new Function(cb);
        // fun.call(this);
      }
      sessionStorage.setItem("title", "");
    },

    // 发布公告
    noticeManage() {
      this.$get(`${this.$store.state.api.webUrl}/userobtain/isPushNotice`, {}, (data) => {
        if (data == 1) {
          //可以正常发公告
          this.$get(
            `${this.$store.state.api.baseWebUrl}/dlms/login/getUrl`,
            {},
            (data) => {
              window.open(data);
            }
          );
        }
        if (data == 2) {
          //需要领取免费机会
          this.$refs.power.openDialog();
          // this.isPower = true
          // this.$refs.tryon.openFreeVipInfo()
        }
        if (data == 3) {
          //免费领取的机会已到期
          this.isPower = true;
          this.$refs.tryon.openFreeVipInfo();
        }
      });
    },

    // 商业智能
    businessIntelligence(href) {
      this.$get(`${this.$store.state.api.webUrl}/business/businessVIP`, {}, (data) => {
        if (data === '1') {
          this.$router.push(href)
        }else {
          this.isPower = true;
          this.$refs.tryon.openFreeVipInfo();
        }
      });
    },

    // 招标文件审查
    zbwjReview() {
      this.$get(`${this.$store.state.api.webUrl}/zbwj/checkVIP`,{type:'bid-review'},(res)=>{
        const data = res.tdata || res
        if(data.isVip && data.redirectUrl){
           // window.open(res.redirectUrl)
           this.$router.push('/deal-nav/bid-review')
        }else{
           this.isPower = true;
           this.$refs.tryon.openFreeVipInfo();
        }
      })
    },

    // 招标文件采购编制
    purchaseFileGenerate() {
      this.$get(`${this.$store.state.api.webUrl}/zbwj/checkVIP`,{type:'purchase-files-generate'},(res)=>{
        const data = res.tdata || res
        if(data.isVip && data.redirectUrl){
           this.$router.push('/deal-nav/purchase-files-generate')
        }else{
           this.isPower = true;
           this.$refs.tryon.openFreeVipInfo();
        }
      })
    },

    // 采购文件编制登录
    getSedToken() {
      this.$refs.tryon.checkUserState();
    },

    ...mapMutations({
      updateData: "userinfo/updateData",
    }),

    ...mapActions({
      queryUserInfo: "userinfo/queryUserInfo",
    }),
    handleSelect(index, indexPath) {
      var data = this.$store.state.config.newNav;
      var item = data.filter((e) => {
        return e.id == indexPath[0];
      });
      if (item[0].children && item[0].children.length) {
        var children = item[0].children;
        var ch = children.filter((e) => {
          return e.id == indexPath[1];
        });
        if (ch.length) {
          var cb = ch[0].click;
          var href = ch[0].href;
          var title = ch[0].title;
          if (cb) {
            try {
              if (title === "一键发公告" || title === "招标采购文件编制") {
                this.$store.dispatch("analysis/updateHits", { visitlocation: title });
              }
              this[cb](href);
            } catch (error) {}
            if (!href) {
            }
          } else {
            if (href) {
              this.$router.push(href);
            } else {
              this.$store.dispatch("analysis/updateHits", { visitlocation: title });
              if (title === "专家抽取") {
                //专家抽取
                window.open("https://cq.yunzikongjian.com/cqzjIndex.html");
              }
              if (title === "招标代理抽取") {
                //招标代理抽取
                window.open("https://cq.yunzikongjian.com/cqdwIndex");
              }
            }
          }
        }
      } else {
        var cb = item[0].click;
        var href = item[0].href;
        var id = item[0].id;
        var title = item[0].title;
        if (cb) {
          try {
            if (title === "一键发公告") {
              this.$store.dispatch("analysis/updateHits", { visitlocation: title });
            }
            this[cb]();
          } catch (error) {}
          if (!href) {
          }
        } else {
          if (id === "9") {
            this.$store.dispatch("analysis/updateHits", { visitlocation: title });
            //专家抽取
            window.open("https://cq.yunzikongjian.com/cqzjIndex.html");
          } else {
            this.$router.push(href);
          }
        }
      }
      sessionStorage.setItem("title", "");
    },
    closeTryon() {
      var oldIndex = this.activeIndex;
      this.activeIndex = "";
      this.$nextTick(() => {
        this.activeIndex = oldIndex;
      });
    },
    setDefaultIndex(name) {
      //首页特殊处理
      name = name == "/" ? "home" : name;
      var data = this.$store.state.config.newNav;
      var nData = [];
      data.forEach((e) => {
        if (e.children && e.children.length) {
          nData.push({
            title: e.title,
            href: e.href || "",
            activeReg: e.activeReg || "",
            nodeid: e.nodeid || "",
            id: e.id,
          });
          nData = nData.concat(e.children);
        } else {
          nData.push({
            title: e.title,
            href: e.href,
            activeReg: e.activeReg,
            nodeid: e.nodeid,
            id: e.id,
          });
        }
      });
      var item = nData.filter((e) => {
        return e.nodeid && name.indexOf(e.nodeid) > -1;
      });
      this.activeIndex = item.length ? item[0].id : "";
    },
  },
  mounted: function () {
    //判断是否为手机端，如果是手机端浏览器打开，则跳转h5宣传页
    var u = navigator.userAgent;
    if (/iPhone|iPad|iPod|Android/i.test(u)) {
      window.location.href =
        process.env.NODE_ENV === "development"
          ? "http://192.168.1.56:8095/#/"
          : "https://huizhao.yunzikongjian.com/advert/#/index";
      return;
    }
    var path = this.$route.path;
    //  判断地址是否是以 "/deal-nav" 开头
    if (path.indexOf("/deal-nav") == 0) {
      // 如果是,则展示 交易导航 搜索组件
      this.useSearchDeal = true;
    } else {
      // 如果不是则展示默认搜索组件
      this.useSearchDeal = false;
    }

    //用来判定用户有没有退出登录,用来处理同时打开多个已登录的浏览器页面，退出其中一个，其他的页面刷新后也保持未登录态
    if (Object.keys(this.userinfo).length > 0) {
      //已登录
      this.queryUserInfo({ requery: true });
      this.setDefaultIndex(this.$route.path);
    } else {
      //已退出或未登录
      this.$store.commit("userinfo/upateLoginOutState", {
        show: false,
        callback: null,
      });
    }

    if(window.electronApi) {
      this.showClientBtns = true
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@css/var.scss";
@media screen and (max-width: 1440px){
  .search{
    margin-top: 0;
  }
  .header-com {
    float: left;
    margin-left: 0 !important;
  }
  img.logo {
    display: none !important;
  }
}
.header {
  overflow: hidden;
  cursor: default;
  height: 70px;
  background: white;
  box-shadow: 0px 1px 6px 0px rgba(61, 126, 255, 0.15);

  .content {
    width: 100%;
    margin: 0 auto !important;
  }

  .search {
    margin-top: 5px;
    height: 58px;
    display: flex;
    align-items: center;
  }

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    min-width: 1200px;
  }

  .header-com {
    float: left;
  }

  img.logo {
    height: 45px;
    margin: 10px 0;
  }

  .nav-list {
    font-size: 16px;
    overflow: hidden;
    padding: 26px 0;
    margin-left: 60px;
    margin-right: 60px;

    .nav-item {
      float: left;
      cursor: pointer;
      color: #333;
      position: relative;
      line-height: 1em;
      font-size: inherit;

      &:hover {
        color: $primaryColor;
      }

      & + .nav-item {
        margin-left: 27px;
      }

      &.active {
        font-weight: bolder;
        color: $primaryColor;
      }
    }
  }

  .deal-nav {
    margin-left: 0px;
  }
}

.child-item {
  color: #333333;
}

.nav-menu {
  font-size: 16px;
  overflow: hidden;
  margin-left: 50px;
  margin-right: 50px;
  display: flex;
  align-items: center;
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .collaspe {
    margin-right: 30px;
    i {
      font-size: 30px;
    }
  }
}

.menu-title {
  font-size: 16px;
}
.menu-submenu-title:hover {
  color: $primaryColor;
}

.clientBtns {
  float: right;
  -webkit-app-region: no-drag;
}
</style>
